/**
 * @fileoverview PRNG seedável (Mulberry32) pra geração determinística de
 * dados falsos. Mesma seed → mesma massa de dados em todo reload, o que
 * facilita validação visual e testes unitários.
 *
 * Mulberry32 é simples, rápido e tem distribuição uniforme suficiente
 * pra dados de demonstração. NÃO é criptograficamente seguro.
 */

export const createRng = (seed = 0xCafeBabe) => {
  let state = seed >>> 0;
  return () => {
    state = (state + 0x6D2B79F5) >>> 0;
    let t = state;
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
};

// Helpers em cima do rng
export const rngInt = (rng, min, max) => {
  // inclusive [min, max]
  return Math.floor(rng() * (max - min + 1)) + min;
};

export const rngPick = (rng, arr) => arr[Math.floor(rng() * arr.length)];

export const rngWeighted = (rng, items) => {
  // items: [{ value, weight }] — retorna value baseado em peso relativo.
  const total = items.reduce((s, it) => s + it.weight, 0);
  let r = rng() * total;
  for (const it of items) {
    r -= it.weight;
    if (r <= 0) return it.value;
  }
  return items[items.length - 1].value;
};

export const rngFloat = (rng, min, max) => rng() * (max - min) + min;
